import "./polyfills";
import React, { Component, useEffect } from "react";
import ReactDOM from "react-dom";
import "react-web-vector-icons/fonts";

import * as serviceWorker from "./serviceWorker";

import { BrowserRouter as Router } from "react-router-dom";
import Geocode from "react-geocode";
import "./assets/base.scss";
import Main from "./pages/Main";
import configureStore from "./config/configureStore";
import { Provider } from "react-redux";
import { loadUser } from "./actions/auth";
import { getNotification } from './actions/notification';
import { consts } from "./assets/values/constants";

Geocode.setApiKey(consts.GOOGLE_API_KEY);
Geocode.enableDebug();

const store = configureStore();
const rootElement = document.getElementById("root");

const renderApp = (Component) => {
  store.dispatch(loadUser());
  store.dispatch(getNotification());
  ReactDOM.render(
    <Provider store={store}>
      <Router>
        <Component />
      </Router>
    </Provider>,
    rootElement
  );
};

renderApp(Main);

if (module.hot) {
  module.hot.accept("./pages/Main", () => {
    const NextApp = require("./pages/Main").default;
    renderApp(NextApp);
  });
}

serviceWorker.unregister();
